export default {
  // API_ENDPOINT: 'http://localhost:8000/api',
  API_ENDPOINT: 'https://hidden-everglades-79778.herokuapp.com/api',
  TOKEN_KEY: 'bibliomancer-client-auth-token'
}; 